import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import Button from "../../../../common/Button"
import InputWithButton from "../../../../common/interactive/InputWithButton"
import { searchActions } from "../../../../../store/search"
import RelatedPatientsSearchResults from "./RelatedPatientsSearchResults"
import OutsideClickComponent from "../../../../fragments/OutsideClickComponent"
import { getCaseRelatedPatients, searchPatientByName } from "../../../../../lib/fetchApi"
import { relatedPatientActions } from "../../../../../store/relatedPatient"
import RelatedPatientItemAdd from "./RelatedPatientItemAdd"

import classes from './FindRelatedPatients.module.css'

const FindRelatedPatients = ({permission, readOnly}) => {
    const dispatch = useDispatch()
    const [isLoading, setisLoading] = useState(false)
    const [searchLoading, setSearchLoading] = useState(false)
    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 
    const relatedPatientCase = useSelector(state => state.relatedPatient.caseSearch)

    const [isSearchOpened, setIsSearchOpened] = useState(false)

    const openRelatedPatiensSearch = async () => {
        setisLoading(true)
        let relatedPatients = await getCaseRelatedPatients(userToken, activeCase.case.id)
        if (relatedPatients && relatedPatients.length > 0) {
            dispatch(relatedPatientActions.setCaseSearch(relatedPatients))
        }
        setIsSearchOpened(prevState => prevState = !prevState)
        setisLoading(false)
    }

    const closeRelatedPatiensSearch = () => {
        setIsSearchOpened(false)
        dispatch(relatedPatientActions.setCaseSearch(null))
        dispatch(searchActions.setRelatedPatientsResults(null))
    }

    const searchPatientHandler = async (event) => {
        event.preventDefault()
        setSearchLoading(true)

        const fd = new FormData(event.target)

        const data = Object.fromEntries(fd.entries())

        if (data.search_related_patient !== '') {
            let search = await searchPatientByName(userToken, data.search_related_patient)
            dispatch(relatedPatientActions.setCaseSearch(null))
     
            dispatch(searchActions.setRelatedPatientsResults(search))

        } else {
            dispatch(searchActions.setRelatedPatientsResults(null))
        }

        event.target.reset()
        setSearchLoading(false)
    }


    return <>
        {permission && !readOnly && <Button click={openRelatedPatiensSearch} btnStyle={'btn_small'} isLoading={isLoading} bypassisCaseArchived={true}>Find Related Patients</Button>}

        {isSearchOpened && <OutsideClickComponent task={closeRelatedPatiensSearch}>
            
                <div className={classes.search_modal_container_wrapper}>
                    <div className={classes.search_modal_container}>
                        <form onSubmit={searchPatientHandler}>
                            <InputWithButton label={'Search Patient'} name={'search_related_patient'} type={'text'} buttonIcon={'ti ti-search'} clearInputExtraTask={closeRelatedPatiensSearch} isLoading={searchLoading}/>    
                        </form>    
                        <RelatedPatientsSearchResults closeModal={closeRelatedPatiensSearch}/>
                    </div>   
                    {relatedPatientCase && <div className={classes.sugestions_container}>
                        <div className={classes.sugestions_container_inner}>
                            <h4 className={classes.suggestion_title}>Suggestions: </h4>
                            {relatedPatientCase.map(item => (
                                <RelatedPatientItemAdd key={item.id} data={item} closeModal={closeRelatedPatiensSearch}/>
                            ))}
                        </div>
                    </div>} 
                </div>
        </OutsideClickComponent>}
    </>
}

export default FindRelatedPatients